import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Landing Page Components
import { Header } from "./components/landing/Header";
import { HeroSection } from "./components/landing/HeroSection";
import { ServicesSection } from "./components/landing/ServicesSection";
import { TikTymSection } from "./components/landing/TikTymSection";
import { VenturesSection } from "./components/landing/VenturesSection";
import { WhyPramalSection } from "./components/landing/WhyPramalSection";
import { EngagementSection } from "./components/landing/EngagementSection";
import { AboutSection } from "./components/landing/AboutSection";
import { ContactSection } from "./components/landing/ContactSection";
import { Footer } from "./components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <TikTymSection />
        <VenturesSection />
        <WhyPramalSection />
        <EngagementSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
